import Api from "./Api"

export default {
    listar(){
        return Api().get(`/productos`);
    },
    listarProductos(page=1, limit, descripcion){
        return Api().get(`/getProductos?page=${page}&limit=${limit}&descripcion=${descripcion}`);
    },
    guardar(datos){
        return Api().post("/productos", datos);
    },
    mostrar(id){
        return Api().get(`/productos/${id}`);
    },
    modificar(id, datos){
        //return Api().put(`/productos/${id}`, datos);
        return Api().put(`/producto/${id}`, datos);
    },
    eliminar(id){
        return Api().delete(`/producto/${id}`);
    },
    listarAtributosAsignados(id){
        return Api().get(`/getAtributosAsignados/${id}`);
    },
}
